import { heroBannerSlideshowProjection } from './pageBuilderProjection';

export const ARTICLES_LIST_CONFIG_QUERY = `
  *[_type == "articlesList" && type == $type][0] {
    ...,
    heroBanner{
      ${heroBannerSlideshowProjection}
    }
  }
`;
